import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "izitoast-react/dist/iziToast.css";
import App from "./App";
import { isCookieAuthMode, loadConfig } from "./config/Config";
import { configureAmplify } from "./config/amplifyConfig";
import LayoutSkeleton from "./components/layoutSkeleton/LayoutSkeleton";
import { initializePostHog } from "./services/analytics";
import { registerGlobalChunkErrorHandler } from "./utils/chunkError";

registerGlobalChunkErrorHandler();

const root = createRoot(document.getElementById("root")!);

function RootApp() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadConfig().then(() => {
      if (!isCookieAuthMode()) configureAmplify();
      initializePostHog();
      setReady(true);
    });
  }, []);

  if (!ready) return <LayoutSkeleton />;

  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

root.render(<RootApp />);
